import { AddPatientTestsRequest, PatientTestsApi } from "../../../api/medical-operations";
import { useRecoilValue } from "recoil";
import { configState } from "../../../recoil/atoms";
import PatientTest from "./Forms/PatientTestForm";
import { Form, Formik } from "formik";
import { Button, Grid } from "@mui/material";
import useStyles from "../../../styles/styles";
import { validationSchema } from "./FormModel/validationSchema";
import { toast } from "react-toastify";

type Props = {
  appointmentID?: string;
};
const AddPatientTests = ({ appointmentID }: Props) => {
  const config = useRecoilValue(configState);
  const classes = useStyles();

  const addPatientTest = (values: AddPatientTestsRequest, actions: any) => {
    const patientTest = new PatientTestsApi(config);
    patientTest
      .addPatientTests(values)
      .then((res) => {
        toast.success(res?.data?.Message!);
        actions.resetForm({});
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = (values: any, actions: any) => {
    actions.setTouched({});
    actions.setSubmitting(false);
    addPatientTest({ ...values, AppointmentID: appointmentID }, actions);
  };

  return (
    <>
      <Formik
        initialValues={{
          ReleaseDate: "",
          TestID: undefined,
          ResultsDocuments: [
            {
              URI: "",
              Type: undefined,
              Description: "",
            },
          ],
          ResultOutcomes: "",
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ dirty, isSubmitting }) => {
          return (
            <Form>
              <PatientTest />
              <Grid className={classes.buttons}>
                <Grid className={classes.wrapper}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={isSubmitting}
                  >
                    Add Test
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddPatientTests;
